import { Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PreparingContract = () => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-linear-to-b from-[hsl(var(--gradient-light-from))] to-[hsl(var(--gradient-light-to))] px-4">
      <div className="relative w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-6 sm:mb-8">
        <div className="absolute inset-0 border-4 border-border rounded-full" />
        <div className="absolute inset-0 border-4 border-selise-blue border-t-transparent rounded-full animate-spin" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-2xl bg-linear-to-br from-[hsl(var(--selise-blue))] to-[hsl(var(--sky-blue))] flex items-center justify-center shadow-lg">
            <Send className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
          </div>
        </div>
      </div>
      <h2 className="text-2xl sm:text-3xl font-bold text-[hsl(var(--fg))] mb-2 text-center">
        {t('GENERATEREVIEW_LOADING_PREPARINGTITLE')}
      </h2>
      <p className="text-sm sm:text-base text-globe-grey text-center">
        {t('GENERATEREVIEW_LOADING_PREPARINGBODY')}
      </p>
    </div>
  );
};

export default PreparingContract;
